export const data = {


    scene: '03_sauvat_matala_plus',
    kysymysteksti: 'Säädit sauvat hieman liian matalalle = lyhyiksi - kyllä ne sauvat pitää olla oikealle korkeudelle säädetty - kokeile säätää vielä uudelleen.',

    optiot: []


};